import { useSpring, animated, config } from "@react-spring/web";
import useLevel from "../../hooks/useLevel";
import { useTranslation } from "react-i18next";
import Button from "./Button";
import useAuth from "../../hooks/useAuth";
import useHashLocation from "../../use-hash-location";
import { useMultiuserContext } from "@solidwhite/multiuser";

const Slogan = ({ visible = false, textId = "L1_SHOWROOM", ...props }) => {
  const [currentLevel] = useLevel();
  const { t } = useTranslation();
  const { currentUser } = useAuth();

  const { spectating } = useMultiuserContext();

  const [location, setLocation] = useHashLocation();

  const spring = useSpring({
    from: { opacity: 0 },
    opacity: visible ? 1 : 0,
    config: { duration: 200 },
  });

  const handleGetInTouchClick = () => {
    window.open(t("BUTTON_GET_IN_TOUCH_URL"), "_blank").focus();
  };

  const handleLoginClick = () => {
    setLocation(`${location.replace("/cta", "")}/login`);
  };

  return (
    <animated.div
      style={{
        color: "#fff",
        padding: 0,
        margin: 0,
        position: "absolute",
        left: "2vw",
        top: "50%",
        transform: "translate(0, -50%)",
        maxWidth: "27%",
        transition: "0.25s",
        opacity: spring.opacity,
        pointerEvents: "none",
      }}
    >
      <p
        style={{
          marginTop: 0,
          marginBottom: "0.5vw",
          // paddingRight: "8.4vw",
          fontSize: "1.4vw",
          fontWeight: "500",
          color: "#37a46e",
        }}
      >
        {t(`${textId}_NAME`)}
      </p>
      <h2
        style={{
          margin: 0,
          fontSize: "2.5vw",
          fontWeight: "100",
          lineHeight: "1.1",
        }}
      >
        {t(`${textId}_SLOGAN`)}
      </h2>
      <p
        style={{
          marginTop: "1vw",
          marginBottom: 0,
          paddingRight: "6vw",
          fontSize: "0.9vw",
          fontWeight: "100",
          lineHeight: "1.2vw",
        }}
      >
        {t(`${textId}_TEXT`)}
      </p>
      <div
        style={{
          width: "90%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          pointerEvents: "all",
          marginTop: "1.5vw",
          display: currentUser == null && !spectating ? "flex" : "none",
        }}
      >
        {/* <Button textId="BUTTON_LOGIN" onClick={handleLoginClick} /> */}
        <Button textId="BUTTON_GET_IN_TOUCH" onClick={handleGetInTouchClick} />
      </div>
    </animated.div>
  );
};

export default Slogan;
